import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import * as _ from 'underscore';
import { LocalStorageService } from '../_services/local-storage.service';
import { PersonSearchService } from '../_services/person-search.service';
import { Highlights } from './Highlights';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, Validators } from '@angular/forms';
import { BulkRevealModalComponent } from '../bulk-reveal-modal/bulk-reveal-modal.component';
import { CampaignService } from '../_services/campaign.service';
import { CandidateService } from '../_services/candidate.service';
import { GlobalService } from '../_services/global.service';
import { SimilarCandidateFilterComponent } from '../similar-candidate-filter/similar-candidate-filter.component';
import { Router } from '@angular/router';
import { AiModalScComponent, SCPassData } from '../ai-modal-sc/ai-modal-sc.component';
import { Observable, from } from 'rxjs';
import { FilterDataHandlerService } from '../_services/filter-data-handler.service';


type FFHUnicornTierOne = {
  fortune500: string[];
  unicorn: string[];
  tierOneSchools: string[];
};

@Component({
  selector: 'app-candidate-quick-view',
  templateUrl: './candidate-quick-view.component.html',
  styleUrls: ['./candidate-quick-view.component.scss']
})
export class CandidateQuickViewComponent implements OnInit {

  public revealableInfo: { key: string, text: string, data?: string | string[], can_reveal: boolean, icon: string, is_revealed?: boolean }[] = [];
  work_email: any;
  personal_email: any;
  phones: any;
  canShowPhone: boolean;
  canShowPersonal_email: boolean;
  canShowWork_email: boolean;

  hideLookingForMore: boolean = false
  showMoreContactDetails: boolean = false;
  loggedInUserName: string = ''

  get hasRevealableInfo() {
    return this.revealableInfo.length > 0;
  }

  get hasWorkEmail() {
    return !!(this.data.work_email && this.data.work_email.length);
  }

  get hasPersonalEmail() {
    return !!(this.data.personal_email && this.data.personal_email.length);
  }

  constructor(private _localStorageService: LocalStorageService,
     private personSearchService: PersonSearchService,
     private modalService: NgbModal,
     private _localstorageservice: LocalStorageService,
     private emailCampaignService: CampaignService,
     public candidateservice: CandidateService,
     private router: Router,
     private filterDataHandlerService: FilterDataHandlerService
    ) { 
    this.loggedInUserName =  this._localStorageService.getItem('ufname') + " " + this._localStorageService.getItem('ulname')  
  }
  
  @Input() data: any;
  @Input() i: any;
  experience: any;
  formattedSkills: any = [];
  currentJobTitle: any;
  currentCompany: any;
  currentLocation: any = null;
  currentStartDate: any;
  currentTenure: any;
  totalTenure: any;
  uniqueProfiles: any = {};
  linkedin_url: any = null;
  facebook_url: any = null;
  twitter_url: any;
  github_url: any;
  stackoverflow_url: any;
  behance_url: any;
  dribbble_url: any;
  medium_url: any;
  quora_url: any;
  temp: any = {};
  @Output() childEvents = new EventEmitter<{action : string, data: any}>();
  @Output() refreshCurrentView: EventEmitter<any> = new EventEmitter();


  
  revealableInfoObj: any = {};
  revealContact: boolean = true;
  displayContactIcon: any = [];
  highlights: MatchHighlights;
  similarcandidate: boolean = false;

  coloursArray = ['#B9D4F4', '#B9D4F4', '#B9D4F4', '#FFF9D7', '#E1D8E9'];
  clonedExperience : any = []
  /**
   * Set when any one of experience has title 
   */
  isPastExperienceToBeShown : false
  canShowContactText: boolean = true;
  @Input() highlightkeywords :any= [];

  primaryCompanyInformation:any = {};
  currentCompanyInformation:any  = {};
  vievmoresoircechip:boolean

  highlightsPillData = new Highlights();
  @Input() similarobjectdata: any;
  @ViewChild('addCandidateToEmailCampaign') addCandidateToEmailCampaign: TemplateRef<any>;
  emailFoundCount: number;
  campaignList: any;
  selectedCampaign: any;
  campaign_input = new FormControl(null, [Validators.required]);
  candidateIdentifier: number | null;
  successMessage: string;
  errorMessage: string;
  currentexplocation:string;
  /**To Know the pending status of api */
  isLoadingEmailCampaignApi: boolean = false;

  get showMatchedSkills() {
    return (this.data && this.data?.highlight && (this.data?.highlight['skills'] || this.data?.highlight['skills.keyword'])) ? true : false;
  }

  ngOnInit(): void {
    const tabName = this._localStorageService.getItem('tabName');
    this.totalTenure = this.getFormattedTenure(this.data.totaltenure);

    this.similarcandidate = (tabName === "similarcandidate");
    if(this.similarcandidate || this.similarobjectdata) {
      this.highlights = getFormattedHighlights(this.data.highlight, this.similarobjectdata && this.similarobjectdata.data && this.similarobjectdata.data.totaltenure, this.similarobjectdata && this.similarobjectdata.data && this.similarobjectdata.data.currentlocation, this.similarobjectdata && this.similarobjectdata.data && this.similarobjectdata.data.locationregion, this.data.totaltenure ? this.data.totaltenure: null)
    }
    this.segregateContactWithProviders();
    this.setHighlightsData();
    this.currentLocation = this.data.location_name; // ? this.data.location_name : this.data.location_names && this.data.location_names.length ? this.data.location_names[0] : null;
    this.linkedin_url = this.data.linkedin_url;

    this.data.experience = this.data.experience.map(obj => {
      const startDate = obj.start_date ? moment(obj.start_date) : null;
      const endDate = moment(obj.end_date || new Date());
      const totalTenure = endDate.diff(startDate, 'years', true);
      obj.totaltenure = this.getFormattedTenure(totalTenure);
      if (obj.is_primary === true || obj.is_primary === 'true') {
        if(obj){
          this.primaryCompanyInformation = obj.company
          if(this.primaryCompanyInformation && this.primaryCompanyInformation['location']){
            this.primaryCompanyInformation['location'] = obj?.company?.location?.name ? obj?.company?.location?.name : obj.location_names[0]
          }
          if(obj.company && obj.company.name){
            this.currentCompany = obj.company.name;
          }
          if(obj.title && obj.title.name){
            this.currentJobTitle = obj.title.name;
          }
          if(obj.totaltenure){
            this.currentTenure = obj.totaltenure;
          }
          if(obj.location_names.length > 0) {
            this.currentexplocation = obj.location_names[0];
          }
          this.currentStartDate = startDate;
          // if(this.currentLocation == null){
          //   if(obj && obj.company && obj.company.location && obj.company.location.name){
          //     this.currentLocation = obj.company.location.name;
          //   }
          // }
        }
      }
      return obj;
    })

    this.clonedExperience = this.data.experience.filter(obj => obj.is_primary != true  && obj.is_primary != 'true');
    // if(this.clonedExperience && this.clonedExperience.length){
    //   if(this.currentLocation == null){
    //     this.currentLocation = this.clonedExperience[0].company.location.name
    //   }
    // }

    //check any experience has title.name then only show past exp
    this.isPastExperienceToBeShown = this.clonedExperience.some(exp=>{
        return exp.title && exp.title.name
    })
    // this.data.experience = this.data.experience.filter(obj => obj.is_primary != true  && obj.is_primary != 'true');

    // this.data && this.data.profiles && this.data.profiles.forEach(profile => {
    //   this.linkedin_url = this.data.linkedin_url ? this.data.linkedin_url : null;
    //   this.facebook_url = this.data.facebook_url ? this.data.facebook_url : null;
    //   this.twitter_url = this.data.twitter_url ? this.data.twitter_url : null;
    //   this.github_url = this.data.github_url ? this.data.github_url : null;
    //   this.stackoverflow_url = this.data.stackoverflow_url ? this.data.stackoverflow_url : null;
    //   this.behance_url = this.data.behance_url ? this.data.behance_url : null;
    //   this.dribbble_url = this.data.dribbble_url ? this.data.dribbble_url : null;
    //   this.medium_url = this.data.medium_url ? this.data.medium_url : null;
    //   this.quora_url = this.data.quora_url ? this.data.quora_url : null;

    //   if (!this.uniqueProfiles[profile.network]) {
    //     this.uniqueProfiles[profile.network] = profile;
    //     if (profile.network === "linkedin") {
    //       this.linkedin_url = profile.url;
    //     } else if(profile.network === "facebook") {
    //       this.facebook_url = profile.url;
    //     } else if(profile.network === "twitter") {
    //       this.twitter_url = profile.url;
    //     } else if(profile.network === "github") {
    //       this.github_url = profile.url;
    //     } else if(profile.network === "stackoverflow") {
    //       this.stackoverflow_url = profile.url;
    //     } else if(profile.network === "behance") {
    //       this.behance_url = profile.url;
    //     } else if(profile.network === "dribbble") {
    //       this.dribbble_url = profile.url;
    //     } else if(profile.network === "medium") {
    //       this.medium_url = profile.url;
    //     } else if(profile.network === "quora") {
    //       this.quora_url = profile.url;
    //     }
    //   }
    // });

    this.data && this.data.profiles && this.data.profiles.forEach(profile => {
      if (!this.uniqueProfiles[profile.network]) {
        this.uniqueProfiles[profile.network] = profile;
        if (profile.network === "linkedin") {
          if(profile.url && !this.linkedin_url) {
            this.linkedin_url = profile.url; 
          }
        } 
        else if(profile.network === "facebook") {
          this.facebook_url = profile.url;
        } else if(profile.network === "twitter") {
          this.twitter_url = profile.url;
        } else if(profile.network === "github") {
          this.github_url = profile.url;
        } else if(profile.network === "stackoverflow") {
          this.stackoverflow_url = profile.url;
        } else if(profile.network === "behance") {
          this.behance_url = profile.url;
        } else if(profile.network === "dribbble") {
          this.dribbble_url = profile.url;
        } else if(profile.network === "medium") {
          this.medium_url = profile.url;
        } else if(profile.network === "quora") {
          this.quora_url = profile.url;
        }
      }
     
    });

    // enter the revealable info here
    // this.pushRevealableInfo('personal_email', 'Personal Email', this.data.personal_emails, true, 'fas fa-envelope');
    // this.pushRevealableInfo('work_email', 'Professional Email', this.data.work_email, true, 'fas fa-briefcase');
    // this.data.emails && this.data.emails.forEach(email => {
    //   if(email.type == 'professional') {
    //     this.pushRevealableInfo('work_email', 'Professional Email', email.address, true, 'fas fa-briefcase');
    //   } else if(email.type == 'personal') {
    //     this.pushRevealableInfo('personal_email', 'Personal Email', email.address, true, 'fas fa-envelope');
    //   }
    // });
    // this.pushRevealableInfo('mobile_phone', 'Phone Number', this.data.mobile_phone, true, 'fas fa-phone');

    // this.pushRevealableInfo('mobile_phone', 'Phone Number', this.data.phone_numbers, true, 'fas fa-phone');

    

    this.totalTenure = this.getFormattedTenure(this.data.totaltenure);


    if(this.data && this.data?.highlight && (this.data?.highlight['skills'] || this.data?.highlight['skills.keyword'])) {
      this.data.skills.forEach(skill => {
        let highlightData = null;
        const dataForHighlight = skill.trim().toLowerCase().replace(/<.*?>/g, '');
        if(this.data && this.data?.highlight && this.data?.highlight['skills'] ) {
          const highlightFound = this.data && this.data?.highlight && this.data?.highlight['skills'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
          highlightFound && (highlightData = highlightFound); 
        } if(this.data && this.data?.highlight && this.data?.highlight['skills.keyword'] ) {
          const highlightFound = this.data && this.data?.highlight && this.data?.highlight['skills.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
          highlightFound && (highlightData = highlightFound); 
        }
        highlightData && this.formattedSkills.push(highlightData);
      });
    }

    this.data.education = this.data.education.map(obj => {
      if (!(obj.degrees && obj.degrees.length)) {
        if (obj.majors && obj.majors.length) {
          obj.newField = obj.majors[0];
          return obj;
        }
        return obj;
      }

      if (obj.degrees && obj.degrees.length) {
        let degreeWords = obj.degrees[0].split(' ');
        if (degreeWords.length > 2) {
          obj.newField = obj.degrees[0];
        } else {
          let position = 0;
          for (let i = 1; i < obj.degrees.length; i++) {
            degreeWords = obj.degrees[i].split(' ');
            position = i;
            if (degreeWords.length > 2) {
              obj.newField = obj.degrees[i];
              return obj;
            }
          }
          if (obj.majors && obj.majors.length) {
            obj.newField = degreeWords[position] + ' in ' + obj.majors[0];
          }
        }
        if(!obj.newField) obj.newField = obj.degrees.toString().trim().replace(/'/g, "''");
        return obj;
      }
      return obj;
    });
  }

  /**
   * 
   * Intialises all the fields necessary for showing candidate highlights
   * 
   */
  private setHighlightsData() {
    this.highlightsPillData.setTechie(this.isCandidateTechie(this.data));
    this.highlightsPillData.setTalentIndustries(this.getTalentIndustries(this.data?.experience));
    const extraHighlightsDetails = this.getFFHUnicornAndTierOne(this.data?.curatedtalentpooltags);
    this.highlightsPillData.setUnicornCompanies(extraHighlightsDetails.unicorn);
    this.highlightsPillData.setFortuneFH(extraHighlightsDetails.fortune500);
    this.highlightsPillData.setTierOneSchools(extraHighlightsDetails.tierOneSchools);
  }

  /**
   * 
   * @returns An object with list of fortune five hundred, unicorn experience, and tier 1 school experience details.
   * 
   */
  private getFFHUnicornAndTierOne(curatedtalentpooltags) : FFHUnicornTierOne {
    const res = {
      fortune500 : [],
      unicorn : [],
      tierOneSchools : []
    };
    if (!curatedtalentpooltags)
      return res;
    for (let el of curatedtalentpooltags) {
      if (el?.type === "experience" && el?.displayname?.toLowerCase() === "fortune-500" && !!el?.name) { res.fortune500.push(el?.name); }
      else if (el?.type === "experience" && el?.displayname?.toLowerCase() === "unicorn" && !!el?.name) { res.unicorn.push(el?.name); }
      else if (el?.type === "education" && el?.displayname?.toLowerCase() === "tier-1 school" && !!el?.name) { res.tierOneSchools.push(el?.name); }
    }
    res.fortune500 = _.uniq(res.fortune500);
    res.unicorn = _.uniq(res.unicorn);
    res.tierOneSchools = _.uniq(res.tierOneSchools);
    return res;
  }

  getTalentIndustries(experiences: any[]): any {

    let industries : {name: string; exp: {};}[] = [];

    experiences.forEach(el => {
      if (!!el?.company?.industry) 
        industries.push({
          name : el?.company?.industry,
          exp: this.getExperience(el)
        });
    });
    // industries = _.uniq(industries, x => x.name);

    let data = this.getUniqueIndustries(industries)
    return data;
  }

  getUniqueIndustries(industries){
  const uniqueData = this.uniqueExperience(industries);
  return uniqueData;
  
  }

    
  uniqueExperience(data) {
      const result = {};
  
      for (const item of data) {
          const key = `${item.name}`;
        
          if (result[key]) {
              if(item.exp.start_date == result[key].exp.start_date) {
                result[key].exp.year = item.exp.year;
                result[key].exp.month = item.exp.month;
              } else {
                 result[key].exp.year += item.exp.year;
                 result[key].exp.month += item.exp.month;
              
                while (result[key].exp.month >= 12) {
                    result[key].exp.year += 1;
                    result[key].exp.month -= 12;
                  }
              }
          } else {             
              result[key] = {
                  name: item.name,
                  exp: { year: item.exp.year, month: item.exp.month, start_date: item.exp.start_date }
              };
          }
      }
  
      const uniqueAggregatedData = Object.values(result);
      return uniqueAggregatedData;
  }
  
  getExperience(obj: any) {

    let exp = {}

    if(obj.start_date && obj.end_date !==null &&  obj.start_date !==null){

      let startDate = obj.start_date;
      let endDate = obj.end_date;

      const startDateArray = startDate.split("-");
      const endDateArray = endDate.split("-");
  
      const startYear = parseInt(startDateArray[0], 10);
      const startMonth = parseInt(startDateArray[1], 10);
      const endYear = parseInt(endDateArray[0], 10);
      const endMonth = parseInt(endDateArray[1], 10);
      
      let yearDiff = endYear - startYear;
      let monthDiff = endMonth - startMonth;
  
      if (monthDiff < 0) {
        yearDiff--; 
        monthDiff += 12;
      }
  
      exp = {year:yearDiff, month:monthDiff, start_date: startDate}

    }else{

      if( obj.start_date !==null){
      let startDate = obj.start_date;
      const formattedDate = new Date();
      const year = formattedDate.getFullYear();
      const month = formattedDate.getMonth() + 1; 
      const currentDate = `${year}-${month}`;

      const startDateArray = startDate.split("-");
      const endDateArray = currentDate.split("-");
  
      const startYear = parseInt(startDateArray[0], 10);
      const startMonth = parseInt(startDateArray[1], 10);
      const endYear = parseInt(endDateArray[0], 10);
      const endMonth = parseInt(endDateArray[1], 10);
      
      let yearDiff = endYear - startYear;
      let monthDiff = endMonth - startMonth;
  
      if (monthDiff < 0) {
        yearDiff--; 
        monthDiff += 12;
      }
      exp = {year:yearDiff, month:monthDiff, start_date: startDate}
      }
    }
   
    return exp;
  }

  openSliderSection($event, type) {
    // this.revealContact = false;
    let data = $event
    if($event == null){
      data = this.data
    }
    this.handleChildEvents('openNav', null, type, data)
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
      //loadn[0].style.display = 'block'
  }
    /**
   * Handles all child events
   * @param action type of action
   * @param event Evenet
   */
    handleChildEvents(action: string, event?: Event, type: any = null, contactIndex: any = null) {
      let eventData = { action: action, data: { ...this.data, selected: event ? (event.target as HTMLInputElement).checked : this.data.selected , currentIndex: this.i} }
      if(type  == 'show-contact'){
        eventData['type'] = 'show-contact'
      }else if(type == 'show-activity'){
        eventData['type'] = 'show-activity'
      } else if(type == 'show-skills') {
        eventData['type'] = 'show-skills'
      }

      this.childEvents.emit(eventData)
    }
  

  private pushRevealableInfo(key: string, text: string, data: string | string[], can_reveal: boolean = true, icon: string = 'fas fa-briefcase', is_revealed?: boolean) {
    // if (data && Array.isArray(data) && data.length) {
    //   data = data.filter(d => d && d.length);
    // }
    // if (data && typeof data === 'string' && data.length) {
    //   data = [data];
    // }
    // temp  changes for demo
    if(data){
      this.revealableInfo.push({
       key,
       text,
       data,
       can_reveal,
       icon,
       is_revealed
     });
    }

    
    // remove duplicates from revealable info based on key
    this.displayContactIcon = this.revealableInfo.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj['key']).indexOf(obj['key']) === pos;
    });    

    this.revealableInfoObj = this.revealableInfo.reduce((acc, curr) => {
      if (!acc[curr.key]) {
        acc[curr.key] = [curr];
      } else{
        const isDuplicate = acc[curr.key].some((obj) => {
          return obj.data.some((d) => {
            return curr.data.includes(d);
          });
        }
        );
        if (isDuplicate) {
          return acc;
        } else {
          acc[curr.key].push(curr);
          return acc;
        }
      }
      return acc;
    }, {});

  }

  private getFormattedTenure(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if (totalYears > 0 && totalMonths > 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'} ${totalMonths} Mths`;
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      return `${totalMonths} Mths`;
    } else {
      return '';
    }
  }

  openUrl(link, type) {
    if (link.startsWith("www.linkedin") || link.startsWith("www.facebook") || link.startsWith("www.twitter") || link.startsWith("www.github"))
      link = "https://" + link;
    else if (type == 'linkedin' && !(link.includes("https://www.linkedin") || link.includes("https://linkedin") || link.includes("https://in.linkedin") || link.includes("http://linkedin") || link.includes("http://www.linkedin")))
      link = "https://www." + link;
    else if (type == 'facebook' && !(link.includes("https://www.facebook") || link.includes("https://facebook") || link.includes("https://in.facebook") || link.includes("http://facebook") || link.includes("http://www.facebook")))
      link = "https://www." + link;
    else if (type == 'twitter' && !(link.includes("https://www.twitter") || link.includes("https://twitter") || link.includes("https://in.twitter") || link.includes("http://twitter") || link.includes("http://www.twitter")))
      link = "https://www." + link;
    else if (type == 'github' && !(link.includes("https://www.github") || link.includes("https://github") || link.includes("https://in.github") || link.includes("http://github") || link.includes("http://www.github")))
      link = "https://www." + link;
    else if (type == 'website'){
      link = "https://www." + link;
    }
    window.open(link, "_blank")
  }

  viewmoredetails(data, i, type) {
    if (type == 'viewmore') {
      this.vievmoresoircechip= true
      document.getElementById(data + '_less' + i).style.display = 'none'
      document.getElementById(data + '_more' + i).style.display = 'block'
    } else {
      this.vievmoresoircechip= false

      document.getElementById(data + '_less' + i).style.display = 'block'
      document.getElementById(data + '_more' + i).style.display = 'none'
    }
  }

  isBoolean(value: any){
    if (typeof value == 'boolean' || value == 'true') {
      return true;
    }
    return false;
  }

  transform(value: string | string[]): string {
    if (!value) {
      return '';
    }

    if (Array.isArray(value)) {
      value = value[0] || '';
    }

    const regex = /(<.*?>)?([^<>]+)/g;
    const transformedValue = value.replace(regex, (match, htmlTag, text) => {
      if (text) {
        const transformedText = text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
        const result = htmlTag ? `${htmlTag}${transformedText}` : transformedText;
        // remove htmltag
        if (result.includes('<')) {
          return result.replace(/<.*?>/g, '');
        }

        return result;
      }
      return match;
    });

    return transformedValue;
  }

  /**
   * Highlight searched info in results
   * @param data input data to be processed for highlights
   * @param type type of data to be processed for highlights
   */
   highlightInfo(data: string, type: 'current_jobtitle' | 'past_jobtitle' | 'location' | 'skill' | 'currentjobtitle' | 'currentcompany' | 'pastcompany') {
    let keywords: any
    keywords = _.without(this.highlightkeywords, "AND","and","or","OR","not","NOT");
    if(data) {
     const dataForHighlight = data.trim().toLowerCase().replace(/<.*?>'/g, '').replace(/'/g, "");
    // const datafind = keywords.filter(x=>dataForHighlight.includes(x.replace(/[()*"]/g, '').toLowerCase().trim()));
    // if(datafind.length > 0) {
          let highlightedData: any= data;
          let highlightFound: any;
          switch (type) {
            case 'current_jobtitle':
              {
               if(this.data && this.data?.highlight && this.data?.highlight['experience.title.name'] ) {
                const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.title.name'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound); 
               } if(this.data && this.data?.highlight && this.data?.highlight['experience.title.name.keyword']) {
                const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.title.name.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound); 
               } if(this.data && this.data?.highlight && this.data?.highlight['job_title.keyword']) {
                const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_title.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound); 
               } if(this.data && this.data?.highlight && this.data?.highlight['job_title']) {
                const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_title'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                highlightFound && (highlightedData = highlightFound); 
               }
             }
              
              break; 
            case 'past_jobtitle':
              {
                if(this.data && this.data?.highlight && this.data?.highlight['experience.title.name'] ) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.title.name'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound); 
                 } if(this.data && this.data?.highlight && this.data?.highlight['experience.title.name.keyword']) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.title.name.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound); 
                 } if(this.data && this.data?.highlight && this.data?.highlight['job_title.keyword']) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_title.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound); 
                 } if(this.data && this.data?.highlight && this.data?.highlight['job_title']) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_title'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound); 
                 }
              }
              break;
            case 'location':
              {
                if(this.data && this.data?.highlight && this.data?.highlight['location_name'] ) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['location_name'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound); 
                } if(this.data && this.data?.highlight && this.data?.highlight['location_locality'] ) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['location_locality'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound); 
                } if(this.data && this.data?.highlight && this.data?.highlight['location_name.keyword'] ) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['location_name.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound); 
                }
                // const highlightFound = (this.data && this.data.highlight && this.data.highlight['location_name'] || this.data && this.data?.highlight && this.data?.highlight['location_locality'] || this.data && this.data?.highlight && this.data?.highlight['location_name.keyword'] || []).find((loc: string) => dataForHighlight.includes(loc.replace(/<.*?>/g, '').trim().toLowerCase()));
               
                // highlightFound && (highlightedData = highlightFound);
              }
              break;
            case 'skill':
              {
                if(this.data && this.data?.highlight && this.data?.highlight['skills'] ) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['skills'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound); 
                } if(this.data && this.data?.highlight && this.data?.highlight['skills.keyword'] ) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['skills.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound); 
                }
             }
              break;
              case 'currentjobtitle':
                {
                  if(this.data && this.data?.highlight && this.data?.highlight['experience.title.name'] ) {
                    const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.title.name'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                    highlightFound && (highlightedData = highlightFound); 
                   } if(this.data && this.data?.highlight && this.data?.highlight['experience.title.name.keyword']) {
                    const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.title.name.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                    highlightFound && (highlightedData = highlightFound); 
                   } if(this.data && this.data?.highlight && this.data?.highlight['job_title.keyword']) {
                    const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_title.keyword'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                    highlightFound && (highlightedData = highlightFound); 
                   } if(this.data && this.data?.highlight && this.data?.highlight['job_title']) {
                    const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_title'].find((title: string) => title.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                    highlightFound && (highlightedData = highlightFound); 
                   }
                }
                break; 
            case 'currentcompany':
              {
                if(this.data && this.data?.highlight && this.data?.highlight['job_company_name'] ) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_company_name'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound); 
                 } if(this.data && this.data?.highlight && this.data?.highlight['job_company_name.keyword']) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_company_name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound); 
                 } if(this.data && this.data?.highlight && this.data?.highlight['experience.company.name']) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.company.name'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound); 
                 } if(this.data && this.data?.highlight && this.data?.highlight['experience.company.name.keyword']) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.company.name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound); 
                 }
              }
            break; 
            case 'pastcompany':
              {
                if(this.data && this.data?.highlight && this.data?.highlight['job_company_name'] ) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_company_name'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound); 
                 } if(this.data && this.data?.highlight && this.data?.highlight['job_company_name.keyword']) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['job_company_name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound); 
                 } if(this.data && this.data?.highlight && this.data?.highlight['experience.company.name']) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.company.name'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound); 
                 } if(this.data && this.data?.highlight && this.data?.highlight['experience.company.name.keyword']) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['experience.company.name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').trim().toLowerCase() === dataForHighlight);
                  highlightFound && (highlightedData = highlightFound); 
                 }
                 if(this.data && this.data?.highlight && this.data?.highlight['lastjob_company_name.keyword']) {
                  const highlightFound = this.data && this.data?.highlight && this.data?.highlight['lastjob_company_name.keyword'].find((company: string) => company.replace(/<.*?>/g, '').replace(/'/g, "").trim().toLowerCase() === dataForHighlight.replace(/'/g, ""));
                  highlightFound && (highlightedData = highlightFound); 
                 }
                 

              }
            break; 
          }
    
          return highlightedData;
      }
  
    //  }
    


    return data;
  }

  getkeywords(data) {
    const hightlights = this.highlightkeywords.find((skill: string) => data.replace(/<.*?>/g, '').includes(skill.toLowerCase().trim()));
    return hightlights;
  }

  selectRandomNumberForColor(){
    return Math.floor(Math.random() * this.coloursArray.length)
  }

  hideContactText(){
    this.canShowContactText = false;
  }

  toShowMoreContactDetails(){
    const falseValues = []
    Object.keys(this.data.contactDetails).forEach(x => {
      Object.keys(this.data.contactDetails[x]).forEach(y => {
        if(this.data.contactDetails[x][y] === false){
          falseValues.push(y)
        }
      })
    })


    if(falseValues && falseValues.length >= 1){
      return true
    }else{
      return false;
    }

  }

  segregateContactWithProviders(){
    if(this.data && this.data.existingContactDetails){
      this.work_email = this.data.existingContactDetails.filter(x => x.contactdetailcategory == "professional")
      this.personal_email = this.data.existingContactDetails.filter(x => x.contactdetailcategory == "personal")
      this.phones = this.data.existingContactDetails.filter(x => x.contactdetailcategory == null)

      if((this.work_email && this.work_email.length) ||
         (this.personal_email && this.personal_email.length) ||
         (this.phones && this.phones.length)){
          this.hideLookingForMore = false;
          this.showMoreContactDetails = true;

          if((this.work_email && this.work_email.length) &&
          (this.personal_email && this.personal_email.length) &&
          (this.phones && this.phones.length)){
            this.showMoreContactDetails = false;

          }

         }else{
          this.hideLookingForMore = false
          this.showMoreContactDetails = false
         }

      if(this.phones && this.phones.length){
        this.canShowPhone = true;
      }else{
        this.canShowPhone = false;
      }

      if(this.personal_email && this.personal_email.length){
        this.canShowPersonal_email = true
      }else{
        this.canShowPersonal_email = false
      }

      if(this.work_email && this.work_email.length){
        this.canShowWork_email = true;
      }else{
        this.canShowWork_email = false;
      }
    }else{
      if(this.data && this.data.contactDetails && this.data.contactDetails.pdl){
        if(this.data.contactDetails.pdl.phone == true){
          this.canShowPhone = true;
        }else{
          this.canShowPhone = false
        }

        if(this.data.contactDetails.pdl.work_email == true){
          this.canShowWork_email = true;
        }else{
          this.canShowWork_email = false
        }

        if(this.data.contactDetails.pdl.personal_email == true){
          this.canShowPersonal_email = true;
        }else{
          this.canShowPersonal_email = false
        }
      }
      

      // if(this.data){
      //   if(this.data.contactDetails && this.data.contactDetails.pdl){
      //     if(this.data.contactDetails.pdl.phone == true && this.data.contactDetails.pdl.work_email == true && this.data.contactDetails.pdl.personal_email == true){
      //          this.showMoreContactDetails = false;
      //     }else{
      //         this.hideLookingForMore = true;
      //         this.showMoreContactDetails = true;
      //     }
      //   }
      // }
    }


    // if(this.canShowPhone == false && this.canShowPersonal_email == false && this.canShowWork_email == false ){
    //   this.showMoreContactDetails = false;
    // }
    // if(this.canShowPhone == true && this.canShowPersonal_email == true && this.canShowWork_email == true ){
    //   this.showMoreContactDetails = false;
    // }else {
    //   this.showMoreContactDetails = true;
    // }
  }

  convertEm(input: string): string {
    return input;
  }

  transformMultiple(data){

    const modifiedArray = []
    if(Array.isArray(data)){

      data.forEach(value => {
        modifiedArray.push(value.replaceAll('<em>', '').replaceAll('</em>', ''))
      })


    }
    return modifiedArray.join(' , ');
  }


  getLikelyToMoveIn(){

  }
  
  getCompanyInfo(type:string, data: any, event){
    const loadn = document.querySelectorAll<HTMLElement>('.loading-screen-wrapper');
    //loadn[0].style.display = 'none'
    // this.currentCompanyInformation = {}
    let companyData = {}
    let pastCompanyData = data?.company

    if(type == 'main'){
      if(!this.primaryCompanyInformation?.website){
        return;
      }
      companyData = {
        companynames: [this.primaryCompanyInformation?.name]
      }
    }else if(type == 'past'){
      if(!pastCompanyData?.website){
        return;
      }
      companyData = {
        companynames: [pastCompanyData?.name]
      }
    }
    this.personSearchService.getCompanyLogo(companyData).subscribe((res: any) => {
      if(res.status == 'success' && res.message){
        let companyDetails = res.message[0]        
        if(type != 'main'){
        this.currentCompanyInformation['website'] = companyDetails.website ? companyDetails.website : pastCompanyData.website
        this.currentCompanyInformation['name'] = companyDetails.name ? companyDetails.name : pastCompanyData?.name
        this.currentCompanyInformation['industry'] = companyDetails?.industry ? companyDetails?.industry : pastCompanyData?.industry
        this.currentCompanyInformation['location'] = companyDetails?.location?.name ? companyDetails?.location?.name : pastCompanyData?.location?.name
        this.currentCompanyInformation['size'] = companyDetails?.size ? companyDetails?.size : pastCompanyData?.size
        this.currentCompanyInformation['linkedin_url'] = companyDetails?.linkedin_url ? companyDetails?.linkedin_url : pastCompanyData?.linkedin_url
        this.currentCompanyInformation['companylogo'] = res.message[0].companylogo
        this.currentCompanyInformation['tags'] = res.message[0].tags
        this.currentCompanyInformation['id'] = res.message[0].id
        this.currentCompanyInformation['key_id'] = res.message[0].id

        }
        if(type == 'main'){
        this.primaryCompanyInformation['companylogo'] = res.message[0].companylogo
        this.primaryCompanyInformation['tags'] = res.message[0].tags
        this.primaryCompanyInformation['key_id'] = res.message[0].id

        }      
          //loadn[0].style.display = 'block'
        
      }
    });
  }

  isCandidateTechie(data: any) : boolean {
    let isTechie = false;
    if (!!data.profiles && !!data.profiles.length) {
      isTechie = data.profiles.some(item => item.network == "stackoverflow");
    }
    isTechie = isTechie || !!data.github_url;
    return isTechie;
  }
  
  print(){
    this.temp = this.data.profiles;
    this.temp = _.uniq(this.temp, "network");
  
  }

  redirecttoSimilarList() {
    this.personSearchService.getdetailsfromlinkedin(this.linkedin_url).subscribe((res:any)=>{
      if(res.status == "success") {
        if(res.data) {
          const pastindustries = _.pluck(res.data.experience, 'company')
          const schools = _.pluck(res.data.education, 'school')
          const locations = []
          res.data.location_locality && locations.push(res.data.location_locality);
          res.data.location_region && locations.push(res.data.location_region);
          res.data.location_country && locations.push(res.data.location_country);
        
          const totalTenure = res.data.totaltenure || 0;
          const fromYrsOfExperience = (parseInt(totalTenure) - (parseInt(totalTenure) * 0.25));
          const toYrsOfExperinece = (parseInt(totalTenure) + (parseInt(totalTenure) * 0.25));
  
           const similarObject = {
            jobtitle: res.data.job_title ? [{ key: res.data.job_title, isMandatory: true }] : [],
            jobcompanyname: res.data.job_company_name ? [{ key: res.data.job_company_name, isMandatory: false }] : [],
            jobindustryname: res.data.job_company_industry ? [{ key: res.data.job_company_industry, isMandatory: true }] : [],
            pastindustries: _.pluck(pastindustries, 'industry'),
            schools: schools && schools.length ? _.pluck(schools, 'name').map(el => ({key: el, isMandatory: false})) : [],
            currentlocation: _.uniq(locations).map(l => ({ key: l, isMandatory: false })),
            skills: res.data.skills ? res.data.skills.map(s => ({ key: s, isMandatory: false })) : [],
            elasticid: res.data.id,
            companysize: res.data.job_company_size ? [{ key: res.data.job_company_size, isMandatory: false }] : [],
            fullname: res.data.full_name,
            linkedinurl: this.linkedin_url,
            isUploadedFromResume: false,
            locationregion: res.data.location_region,
            locationcontinent: res.data.location_continent,
            totaltenure: totalTenure,
            fromYrsOfExperience,
            toYrsOfExperinece
  
          }      

          const modalRef = this.modalService.open(
            AiModalScComponent,
            { size: 'xl', windowClass: 'genAimodal',centered: true, backdrop: 'static', keyboard: false }
          );
          const modalInstance: AiModalScComponent = modalRef.componentInstance;
          modalInstance.similarCandidateData = {data: similarObject, calledfrom: 'view-similar-candidate'} as SCPassData;

          const modalResult$ = from(modalRef.result) as Observable<SCPassData>;
          modalResult$.subscribe(response => this.openSCFilterComponent(response));
        } else if(res.message == 'Person not found') {
        }
      }
    })

  }

  private openSCFilterComponent(scPassData: SCPassData) {
    this.personSearchService.passsimilarcandidatesdata(scPassData);
    const modalRef = this.modalService.open(
      SimilarCandidateFilterComponent, 
      { size: 'xl', windowClass: 'modal-size', centered: true, backdrop: 'static', keyboard: false }
    );
    modalRef.result.then((res) => {
      if (res?.action === 'submit') {
        this.personSearchService.passsimilarcandidatesdata(res);
        this._localStorageService.setItem('similar-candidates-additional-filters', JSON.stringify(res));
        this.redirectToListingFromSC(res.calledfrom);
      }
    });
  }

  private redirectToListingFromSC(calledFrom: string) {
    const downloadLink = document.createElement("a");
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.setAttribute("href", `${environment.frontendurl}/person/search/listing?type=${calledFrom}`);
    downloadLink.setAttribute("target", "_blank");
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }
  
  openAddToEmailCampaign(){
    const modalRef = this.modalService.open(this.addCandidateToEmailCampaign, { size: 'xs' as 'lg', centered: true, backdrop : 'static', keyboard : false });
  }

  onTypeAheadSearch(event: string): void {
    const query = event;
    this.emailCampaignService.getCampaigns({campaign_name: query, created_by: this._localstorageservice.getItem('userdata').userid, 'status[]': [1,2]}).subscribe((data) => {
      this.campaignList = data['data'];
    });
  }

  // Add this function to handle the selection from the typeahead
  onCampaignSelected(value): void {
    this.selectedCampaign = value;
    this.campaign_input.setValue(value.campaign_name);
  }

  addToEmailCampaign() {
    this.isLoadingEmailCampaignApi = true;
    this.campaign_input.markAllAsTouched();
    if(this.campaign_input.valid && this.selectedCampaign){
      const campaign_id = this.selectedCampaign.campaign_id;
      let unsubscribedCandidateCount = 0;
      let payloadArray = (Array.isArray(this.data) ? this.data : [this.data]).map(x => {
        if(x?.is_unsubscribed){
          unsubscribedCandidateCount++;
          return;
        }
          return {
            firstname: x.first_name,
            target_name: x.full_name,
            target_id: null,
            target_meta: JSON.stringify({
              "candidatenumber": x.candidatenumber && x.candidatenumber.length? x.candidatenumber: null, 
              "elastic_id": x.id,
              "title": x.job_title,
            }),
            
              //elastic || else send 0
            target_email: x.existingContactDetails && x.existingContactDetails.length ? 
                          this.extractPreferredEmail(x.existingContactDetails) : null,
                          
            is_active: true,
            created_on: new Date().toISOString(),
            updated_on: new Date().toISOString()
          };
      }).filter(Boolean);
      const updatedPayloadArray = payloadArray.filter(x => x);
      this.emailFoundCount = 0;
      updatedPayloadArray.forEach(element => {
        if (element.target_email)
          this.emailFoundCount++;
      }
      );

      if(unsubscribedCandidateCount > 0 && updatedPayloadArray.length === 0){
        this.closeActiveModal();
        this.toastmessage("Unsubscribed from Email Campaign", 'error');
        return;
      }
      if (this.data['candidatenumber']) {
        this.emailCampaignService.createTarget(campaign_id, updatedPayloadArray).subscribe((res: any) => {
          if (res.status == 'success') {
            if (res.data && res.data.length) {
              this.refreshCurrentView.emit(this.data)
              this.showEmailCampaignCount()
              this.toastmessage("Candidate added to email campaign successfully", 'success');
              this.closeActiveModal();
              if (this.emailFoundCount !== updatedPayloadArray.length){

                // new payload for openDetail modal that contains mapping of candidate number elastic_id and campaign_targe_id for bulk reveal
                const bulkRevealPayLoad = {
                  enrichedFrom: "person-search-listing",
                  candidates: [],
                  campaign_id: campaign_id
                }

                res.data.map((arr) => {
                  if(!arr?.target_email){
                    bulkRevealPayLoad.candidates.push(
                      {
                        elastic_id: JSON.parse(arr?.target_meta || '{}')?.elastic_id,
                        // candidatenumber: JSON.parse(arr?.target_meta || '{}')?.candidatenumber,
                        campaign_target_id: arr.campaign_target_id
                      }
                    );
                  }
                })
                this.openDetailsModal(campaign_id, bulkRevealPayLoad, this.emailFoundCount, updatedPayloadArray.length);
              }
            }
            else{
              this.closeActiveModal()
              this.toastmessage("Candidate already present in selected campaign", 'error')
            }
          }
          else if (res.status == 'failure') {
            this.closeActiveModal()
            this.toastmessage("candidate addition failed", "error");
          }
        });
      }
      else {
        this.emailCampaignService.migrateCandidates({ elasticid: [this.data.id] }).subscribe((res: any) => {
          const newMeta = JSON.parse(updatedPayloadArray[0].target_meta);
          newMeta.candidatenumber = res.data[0].candidatenumber;
          updatedPayloadArray[0].target_meta = JSON.stringify(newMeta);
          Promise.all(updatedPayloadArray.map(async (x) => {
            x.target_email = await this.getContactDetails(newMeta.candidatenumber, this.getEmailPref(this.selectedCampaign['email_pref']));
            return x;
          })).then((newPayload) => {

            this.emailCampaignService.createTarget(campaign_id, newPayload).subscribe((res: any) => {
              this.isLoadingEmailCampaignApi = false;
              if (res.status == 'success') {
                this.refreshCurrentView.emit(this.data)
                this.showEmailCampaignCount()
                this.toastmessage("Candidate added to email campaign successfully", 'success');
                this.closeActiveModal()
                
                if (this.emailFoundCount !== updatedPayloadArray.length){

                  // new payload for openDetail modal that contains mapping of candidate number elastic_id and campaign_targe_id for bulk reveal
                  const bulkRevealPayLoad = {
                    enrichedFrom: "person-search-listing",
                    candidates: [],
                    campaign_id: campaign_id
                  }

                  res.data.map((arr) => {
                    bulkRevealPayLoad.candidates.push(
                      {
                        elastic_id: JSON.parse(arr?.target_meta || '{}')?.elastic_id,
                        candidatenumber: JSON.parse(arr?.target_meta || '{}')?.candidatenumber,
                        campaign_target_id: arr.campaign_target_id
                      }
                    );
                  })
                  this.openDetailsModal(campaign_id, bulkRevealPayLoad, this.emailFoundCount, newPayload.length);
                }
              }
              else if (res.status == 'failure') {
                this.closeActiveModal()
                this.toastmessage("candidate addition failed", "error");
              }
            })
          })
        })
      }
    } else{
      this.isLoadingEmailCampaignApi = false
    }
  }
  getContactDetails(candidateid, type) {
    return new Promise((resolve, reject) => {
      let data = {
        "usernumber": this._localstorageservice.getItem('usernumber'),
        "candidatenumber": candidateid,
      };
  
      this.candidateservice.getContactDetails(data).subscribe(
        (res: any) => {
          if (res.status === 'success') {
            let email = null;
            if(type=='FirstPersonal'){
              email = res.data.emails.find((x) => x.isprimary && x.contactdetailcategory=='personal')?.contactdetail;
              if(email==null)
                email = res.data.emails.find((x) => x.isprimary && x.contactdetailcategory=='professional')?.contactdetail;
            }
            else if(type=='FirstProfessional'){
              email = res.data.emails.find((x) => x.isprimary && x.contactdetailcategory=='professional')?.contactdetail;
              if(email==null)
                email = res.data.emails.find((x) => x.isprimary && x.contactdetailcategory=='personal')?.contactdetail;
            }
            else{
               email = res.data.emails.find((x) => x.isprimary && x.contactdetailcategory==type)?.contactdetail;
            }
            if (email) {
              resolve(email);
            } else {
              // reject("Primary email not found for the candidate.");
              resolve(null);
            }
          } else {
            reject("Error fetching contact details for the candidate.");
          }
        },
        (error) => {
          reject("An error occurred while fetching contact details.");
        }
      );
    });
  }
  openDetailsModal(campaign_id, payload, emailsFound, total_target){
    const modalRef =  this.modalService.open(BulkRevealModalComponent, { size: 'xs' as 'lg', centered: true , backdrop : 'static', keyboard : false});
    modalRef.componentInstance.campaign_id = campaign_id;
    modalRef.componentInstance.payload = payload;
    modalRef.componentInstance.emailsFound = emailsFound;
    modalRef.componentInstance.campaignDetails = this.selectedCampaign;
    modalRef.componentInstance.total_target = total_target;
    modalRef.componentInstance.calledFor = 'email-campaign';
  }
  closeActiveModal(){
    this.campaign_input.markAsUntouched();
    this.campaign_input.markAsPristine();
    this.campaign_input.reset();
    this.modalService.dismissAll()
  }
  toastmessage(message, type) {
    if (type == 'success') {
      this.successMessage = message;
      setTimeout(() => this.successMessage = '', 5000);
    } else if (type == 'error')
      this.errorMessage = message;
    setTimeout(() => this.errorMessage = '', 5000);
  }
  getEmailPref(data){
    if(data==1){
      return 'personal';
    }
    else if(data==2){
      return 'professional';
    }
    else if(data==3){
      return 'FirstPersonal';
    }
    else{
      return 'FirstProfessional';
    }
  }
  extractPreferredEmail(details){
    if(this.selectedCampaign['email_pref']==1 || this.selectedCampaign['email_pref'] == 2){
      let email = null;
      if(details.filter(x=>x.type=='email' && x.contactdetailcategory==this.getEmailPref(this.selectedCampaign['email_pref'])).length){
        email = details.find(x=>x.type=='email' && x.contactdetailcategory==this.getEmailPref(this.selectedCampaign['email_pref']) && x.isprimary)?.contactdetail
        if(!email) email = details.find(x=>x.type=='email' && x.contactdetailcategory==this.getEmailPref(this.selectedCampaign['email_pref']))?.contactdetail 
      }
      return email || null;
    }
    else if(this.selectedCampaign['email_pref']==3){
      let email = null;
      if(details.filter(x=>x.type=='email' && x.contactdetailcategory=='personal').length){
        email = details.find(x=>x.type=='email' && x.contactdetailcategory=='personal' && x.isprimary)?.contactdetail;
        if(!email) email = details.find(x=>x.type=='email' && x.contactdetailcategory=='personal')?.contactdetail;
      }
      else if( !email && details.filter(x=>x.type=='email' && x.contactdetailcategory=='professional').length){
        email = details.find(x=>x.type=='email' && x.contactdetailcategory=='professional' && x.isprimary)?.contactdetail
        if(!email) email = details.find(x=>x.type=='email' && x.contactdetailcategory=='professional')?.contactdetail
      }
      return email || null;
    }
    else {
      let email = null
      if(details.filter(x=>x.type=='email' && x.contactdetailcategory=='professional').length){
        email = details.find(x=>x.type=='email' && x.contactdetailcategory=='professional' && x.isprimary)?.contactdetail;
        if(!email) email = details.find(x=>x.type=='email' && x.contactdetailcategory=='professional')?.contactdetail;
      }
      else if(!email && details.filter(x=>x.type=='email' && x.contactdetailcategory=='personal' && x.isprimary)?.length){
        email = details.find(x=>x.type=='email' && x.contactdetailcategory=='personal' && x.isprimary)?.contactdetail;
        if(!email) email = details.find(x=>x.type=='email' && x.contactdetailcategory=='personal').contactdetail;
      }
      return email || null;
    }
  }

  getLastActivity(){
    if(this.data.lastseendate && this.data.lastcandidateactivity && this.data.lastcandidateactivity.length){
      const lastSeenDate = new Date(this.data.lastseendate);
      const lastActivityDate = new Date(this.data.lastcandidateactivity[0].createdon);
      
      if (lastSeenDate > lastActivityDate) {
        return 'Profile Viewed by ' + this.data.lastseenbyuser
      } else if (lastActivityDate > lastSeenDate) {
        if(this.data.lastcandidateactivity[0]?.activitytype === "Talentpool"){
          return `Added to talentpool - ${this.data.lastcandidateactivity[0]?.name}`;
        }
        return GlobalService.getPersonSearchActivityText(this.data.lastcandidateactivity[0])
      } else {    
        return 'Profile Viewed by ' + this.data.lastseenbyuser
      }
    }else if(this.data.lastseendate != null){
      return 'Profile Viewed by ' + this.data.lastseenbyuser
    }else if(this.data.lastcandidateactivity && this.data.lastcandidateactivity.length){
      if(this.data.lastcandidateactivity[0]?.activitytype === "Talentpool"){
        return `Added to talentpool - ${this.data.lastcandidateactivity[0]?.name}`;
      }
      return GlobalService.getPersonSearchActivityText(this.data.lastcandidateactivity[0])
    }
  }


  showActivity(){
    if((this.data && this.data.talentpoolcount >= 1) ||
      (this.data && this.data.emailcampaigncount >= 1) ||
      (this.data && this.data.lastseenbyuser !=null) ||
      (this.data && this.data.lastcandidateactivity && this.data.lastcandidateactivity.length)){
        return true
      }else{
        return false
      }
  }

  showEmailCampaignCount(){
    if(this.data && this.data.emailcampaigncount >= 1){
      this.data.emailcampaigncount = this.data.emailcampaigncount + 1
    }else{
      this.data.emailcampaigncount = 1
    }
  }

  truncateString(string){
    if(string && string.length > 17){
      string = string.slice(0,17);
      string += '...';
    }
    return string;
  }
}


function getFormattedHighlights(highlight: any, totalTenure: string, currentlocation: any, region: string, candidatetotaltenure: string): MatchHighlights {
  // console.log("similarobject", this.similarobject)
  const result: MatchHighlights = {};
  if (!highlight)
    return result;

  if (highlight["experience.company.industry.keyword"]) {
    const industries: string[] = highlight["experience.company.industry.keyword"];
    result.industries = _.uniq(industries).join(", ");
  }
  if (highlight["location_locality.keyword"]) {
    const localities: string[] = highlight["location_locality.keyword"];
    result.localities = _.uniq(localities).join(", ");
  }
  if (highlight["location_name.keyword"] || highlight["location_name"]) {

    const locationNames: string[] = highlight["location_name.keyword"] || highlight["location_name"];
    const loc = currentlocation ? currentlocation.map(cl => cl.key.trim().toLowerCase().replace(/<.*?>/g, '')) : null;

    const highlightFound = (locationNames || []).find((lo: string) => lo.replace(/<.*?>/g, '').toLowerCase().trim() == loc);
    if(highlightFound) {
      result.locationNames = _.uniq(locationNames).join(", ");
    
    } else if(region) {
        const loc_region = region.replace(/<.*?>/g, '').toLowerCase().trim();
        const regionfound = (locationNames || []).find((lo: string) => lo.replace(/<.*?>/g, '').toLowerCase().trim().includes(loc_region));
        if(regionfound) {
          result.regionname = region;
        }
      } else {
        result.regionname = null;
      }

    
   
  }
  if (highlight["job_title"]) {
    const titles: string[] = (highlight["job_title"]);
    result.titles = titles[0].replace(/<em[^>]*>/g,'').replace(/<\/em>/g,'');
  }

  if (highlight["skills.keyword"]) {
    const skills: string[] = highlight["skills.keyword"];
    result.skills = _.uniq(skills).join(", ");
  }
  if (highlight["experience.company.name.keyword"] || highlight["experience.company.name"]) {
    const company: string[] = (highlight["experience.company.name.keyword"] || highlight["experience.company.name"]);
    result.company = company[0];
  }
  if (candidatetotaltenure && totalTenure) {
    const fromyrsofexperience = (parseInt(totalTenure) - (parseInt(totalTenure) * 0.25));
    const toyrsofexperinece = (parseInt(totalTenure) + (parseInt(totalTenure) * 0.25));
    if(parseInt(candidatetotaltenure) >= fromyrsofexperience && parseInt(candidatetotaltenure) <= toyrsofexperinece ){
      result.totalTenure = totalTenure;
    }
   
  }
  if (highlight["experience.company.size"]) {
    if((result.locationNames || result.regionname) && result.skills && result.totalTenure && result.titles) {
      result.companySizes = null;
    } else {
      const companySizes: string[] = highlight["experience.company.size"];
      result.companySizes = _.uniq(companySizes).join(", ");
   }

  }

  return result;


  }



